module.exports = __webpack_public_path__ + "img/icon.fa147ee9.png";